// src/screens/UsersScreen.js

import React from "react";

function UsersScreen() {
  return (
    <div className="w-full max-w-none mx-0 px-0 py-1">      <h1 className="text-2xl font-bold text-gray-900">Users</h1>
      <p className="text-gray-600">
        User management will go here later. For now, this is just a placeholder
        screen so the app can build and the layout works.
      </p>

      <div className="mt-4 rounded-lg border border-dashed border-gray-300 bg-white p-4 text-sm text-gray-500">
        <p>
          • Route: <code className="font-mono">/users</code>
        </p>
        <p>• No Firestore reads</p>
        <p>• No extra components</p>
      </div>
    </div>
  );
}

export default UsersScreen;
